import { BaseContainerModel } from '../../base-container.model';
import {bl_fi_mst_branch_settlement_method_import_file_helper_RowClass} from '../../../dbschema/index';

export class BranchStltMtdImportFileHelperContainerModel extends BaseContainerModel {
  bl_fi_mst_branch_settlement_method_import_file_helper: bl_fi_mst_branch_settlement_method_import_file_helper_RowClass = new bl_fi_mst_branch_settlement_method_import_file_helper_RowClass();
  }